module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre6",
    attrs: {
      "id": "pgepubid00007"
    }
  }, [_vm._v("Full Page Illustrations")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0009#norroway_illus"
    }
  }, [_vm._v("THE BLACK BULL OF NORROWAY")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0017#tattercoats_illus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TATTERCOATS")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0025#witch_illus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE OLD WITCH")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0032#castle_illus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE CASTLE OF MELVALES")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0040#bull_illus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE LITTLE BULL-CALF")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0046#lambton_illus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE LAMBTON WORM"), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3179d35c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0